import React, { useEffect, useState } from 'react';
import Image from 'next/legacy/image';
import filterIcon from '@/images/filter-icon.svg';

interface FilterToggleProps {
  open: boolean;
  onClick: (open: boolean) => void;
}

export function FilterToggle({ open, onClick }: FilterToggleProps) {
  const [toggleOn, setToggleOn] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('#99EDC533');

  const updateToggle = (isOn: boolean) => {
    setToggleOn(isOn);
    setBackgroundColor(isOn ? '#99EDC580' : '#99EDC533');
    onClick(isOn);
  };

  useEffect(() => updateToggle(open), [open]);

  return (
    <button
      data-testid="search-filters-toggle"
      type="button"
      onClick={() => updateToggle(!toggleOn)}
      className={`mr-4 inline-block h-full w-14 shrink-0 rounded-full border-[1px] border-teal pt-1 transition-colors duration-300`}
      style={{ backgroundColor }}
    >
      <Image alt="filter" src={filterIcon} />
    </button>
  );
}
